import { render, staticRenderFns } from "./ONotesTable.vue?vue&type=template&id=003a39b8"
import script from "./ONotesTable.vue?vue&type=script&lang=js"
export * from "./ONotesTable.vue?vue&type=script&lang=js"
import style0 from "./ONotesTable.vue?vue&type=style&index=0&id=003a39b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports